import { render } from "./QnaProduct.vue?vue&type=template&id=2744eda0&scoped=true"
import script from "./QnaProduct.vue?vue&type=script&lang=js"
export * from "./QnaProduct.vue?vue&type=script&lang=js"

import "./QnaProduct.vue?vue&type=style&index=0&id=2744eda0&scoped=true&lang=css"

import exportComponent from "/home/hosting_users/shoplus/custom/survey-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2744eda0"]])

export default __exports__